import { Button } from '@navi/web-ui/lib/primitives';
import Typography from '@navi/web-ui/lib/primitives/Typography/Typography';
import CrossIcon from '@cp/src/assets/icons/CrossIcon';
import { AnswerView } from '../../interface';

interface AnswerViewsSectionProps {
  answerViews: AnswerView[];
  onClose: () => void;
}

const AnswerViewsSection = ({ answerViews, onClose }: AnswerViewsSectionProps) => {
  const hasAnswerViews = answerViews.length > 0;

  if (!hasAnswerViews) return null;

  return (
    <div className="relative">
      <Button variant="text" size="small" onClick={onClose} className="absolute top-2 right-2 z-10">
        <CrossIcon fillColor="var(--grayscale-1)" />
      </Button>
      <div className="flex flex-col gap-3 py-4 pl-4 pr-10">
        <div className="grid grid-cols-2 gap-y-3 gap-x-8">
          {answerViews.map((answer, index) => (
            <div key={index} className="flex flex-col">
              <Typography variant="p5" color="var(--grayscale-3)">
                {answer.questionName}
              </Typography>
              <Typography variant="p5" color="var(--grayscale-1)">
                {answer.optionText ||
                  answer.inputText ||
                  answer.inputAmount ||
                  answer.inputDate ||
                  '-'}
              </Typography>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AnswerViewsSection;
